import { Carousel } from "@mantine/carousel";
import { Loader } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import Autoplay from "embla-carousel-autoplay";
import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import CompleteProfile from "../../components/CompleteProfile";
import Page from "../../components/Page";
import RecentJobSeeker from "../../components/RecentJobSeeker";
import { backendUrl } from "../../constants";
import routeNames from "../../routes/routeNames";
import MyPosts from "../Settings/MyPosts";
import PostJob from "./PostUpdate";
import QuickLink from "./QuickLink";
import SearchHistoryModal from "./searchHistoryModal";
import "./styles.css";

const Index = ({ t }) => {
  let userData = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const autoplay = useRef(Autoplay({ delay: 2000 }));
  const [recentSeekers, setRecentSeekers] = useState([]);
  const [searchHistory, setSearchHistory] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [update, setUpdate] = useState({ userId: userData.id, status: "" });
  const [refetch, setRefetch] = useState(false);

  //search Histroy
  useEffect(() => {
    setSearchHistory([]);
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}user/listSearchHistory/${userData.id}`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = {
            id: obj._id,
            label: obj.displayName,
            date: obj.createdDate,
          };
          setSearchHistory((s) => [...s, a]);
        });
      })
      .catch((err) => console.error(err));
  }, [refetch]);

  //recent job seekers
  useEffect(() => {
    setRecentSeekers([]);
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify({ page: "1", size: "20" }),
    };
    fetch(`${backendUrl}user/searchJobSeeker`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = {
            key: obj._id,
            name: obj.displayName,
            title: obj?.jobSeeker[0]?.jobTitle,
          };
          setRecentSeekers((jobseeker) => [...jobseeker, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //post news update
  const handleUpdate = () => {
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(update),
    };
    fetch(`${backendUrl}user/postStatusUpdate`, options)
      .then((response) => {
        setUpdate({ userId: userData.id, status: "" });
        showNotification({
          message: "Posted new update!",
          color: "green",
        });
      })
      .catch((err) => console.error(err));
  };

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="e-dashboard">
        <div className="dash-a">
          <h2 className="text-dark">Welcome Back {userData.firstName}!</h2>
          <div className="shadow quick-links-p">
            <h5 className="text-dark">Quick Links</h5>
            <div className="quick-links">
              <QuickLink
                name="Post a job"
                logo={"job"}
                onClick={() => navigate(routeNames.employer.postAJob)}
              />
              <QuickLink
                name="My Jobs"
                logo={"aplications"}
                onClick={() => navigate(routeNames.employer.myJobs)}
              />
              <QuickLink
                name="Search Job Seekers"
                logo={"job-seeker"}
                onClick={() => navigate(routeNames.employer.searchJokSeeker)}
              />

              <QuickLink
                name="Settings"
                logo={"settings"}
                onClick={() => navigate(routeNames.employer.settings)}
              />
            </div>
          </div>
          <div className="saved-searches shadow">
            <h5 className="text-dark"> Recent Search History</h5>
            <div className="search-list">
              {searchHistory.slice(0).map((obj) => (
                <a href="/" className="text-decoration-none">
                  {obj.label}
                </a>
              ))}
            </div>
            <Button
              title="View All"
              primary={true}
              width="180px"
              style={{ marginLeft: "auto" }}
              onClick={() => setOpenModal(true)}
            />
          </div>
          <PostJob
            handleUpdate={handleUpdate}
            update={update}
            setUpdate={setUpdate}
          />
          <MyPosts />
        </div>
        <div className="dash-b">
          <CompleteProfile />
          <div className="recent-jobseekers">
            {console.log(recentSeekers, "sas")}
            {recentSeekers.length > 0 ? (
              <>
                <h6 className="text-dark text-center mt-5">
                  New Job Seekers in your Area
                </h6>
                <Carousel
                  align="center"
                  plugins={[autoplay.current]}
                  onMouseEnter={autoplay.current.stop}
                  onMouseLeave={autoplay.current.reset}
                  loop
                  slideSize="20%"
                  controlSize={40}
                  slidesToScroll={1}
                  height={"250px"}
                  className="mb-4"
                >
                  {recentSeekers &&
                    recentSeekers.map((obj, key) => (
                      <Carousel.Slide className="m-2" key={key}>
                        <RecentJobSeeker data={obj} key={obj.id} />
                      </Carousel.Slide>
                    ))}
                </Carousel>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        <SearchHistoryModal
          opened={openModal}
          setOpened={setOpenModal}
          searchHistory={searchHistory}
          setRefetch={setRefetch}
        />
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
